import emptyFieldValidate from "@validators/shared/empty.validate";
import urlFieldValidate from "@validators/shared/url.validate";

export type TErrors = {
  title: string | undefined;
  date: string | undefined;
  type: string | undefined;
  gallery: string | undefined;
};

const mediaValidate = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    title: undefined,
    date: undefined,
    type: undefined,
    gallery: undefined,
  };

  errors.title = emptyFieldValidate(FormValues.title, "Title");
  errors.date = emptyFieldValidate(FormValues.date, "Date");
  errors.type = emptyFieldValidate(FormValues.type, "Type");
  errors.gallery =
    typeof FormValues.gallery === "string"
      ? urlFieldValidate(FormValues.gallery, "Gallery")
      : emptyFieldValidate(FormValues.gallery, "Gallery");

  return errors;
};

export default mediaValidate;
